<ion-header [translucent]="true">
  <ion-toolbar color="success">
    <ion-buttons slot="start">
      <ion-menu-button/>
    </ion-buttons>
    <ion-title>Jornada</ion-title>
    <ion-buttons slot="end">
      <ion-icon size="large" (click)="changeHelp()" [name]="helpButton"></ion-icon>
      <ion-icon size="large" *ngIf="!jornada?.inicio && jornada?.monitoramentos?.length >0" name="play-circle-outline"
                (click)="iniciarJornada()"/>
      <ion-icon size="large" *ngIf="!jornada?.pausado && jornada?.inicio" (click)="pausarJornada()"
                name="pause-circle-outline"/>
      <ion-icon size="large" *ngIf="jornada?.inicio" name="stop-circle-outline" (click)="openAlerta()"/>
      <ion-icon size="large" *ngIf="jornada?.pausado && jornada?.inicio" (click)="retomarJornada()"
                name="play-circle-outline"/>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true">
  <ion-note color="medium">
    <span *ngIf=" showHelp && !jornada?.inicio && jornada?.monitoramentos?.length >0" style="font-size: small">
      Aperte <ion-icon name="play-circle-outline"/> para iniciar jornada
    </span>
    <span *ngIf="showHelp && jornada?.pausado && jornada?.inicio" style="font-size: small">
      Aperte <ion-icon name="play-circle-outline"/> para continuar com a jornada ou <ion-icon
      name="stop-circle-outline"/> para finalizar
    </span>
    <span *ngIf="showHelp && !jornada?.pausado && jornada?.inicio" style="font-size: small">
      Aperte <ion-icon name="pause-circle-outline"/> para pausar a jornada ou <ion-icon name="stop-circle-outline"/> para finalizar
    </span>
  </ion-note>
  <form #form="ngForm">
    <ion-list [inset]="true">
      <ion-item [button]="true" detail="false">
        <ion-label><h1>Monitoramentos<br/></h1>
          <ion-note *ngIf=" showHelp && !jornada?.inicio" color="medium">
            <span style="font-size: small">Aperte <ion-icon
              name="add-circle-outline"/> para adicionar monitoramentos</span>
          </ion-note>
        </ion-label>
        <ion-icon *ngIf="!jornada?.inicio"
                  color="success" size="large" slot="end" name="add-circle-outline" (click)="addMonitoramento()"/>
      </ion-item>
      <div *ngFor="let m of jornada?.monitoramentos">
        <div *ngFor="let met of m.metodosOrdenados">
          <ion-item detail="false">
            <ion-badge (click)="showEspecime(true)" *ngIf="!exibirEspecime"
                       slot="start">{{ especiesByMetodo(m, met)?.length || 0 }}
            </ion-badge>
            <ion-icon (click)="showEspecime(false)" *ngIf="exibirEspecime" slot="start"
                      name="arrow-down-outline"></ion-icon>

            <ion-label id="metodo" (click)="exibir(met, m, $event)">
              {{header(met, m)}}

              <ion-note *ngIf="showHelp && jornada?.inicio" color="medium">
                <span style="font-size: small">Aperte o botão <ion-icon
                  name="add-circle"/> para adicionar indivíduos.<br/></span>
                <span *ngIf="m.especimes.length > 0" style="font-size: small">Aperte o botão <ion-badge>{{ especiesByMetodo(m, met)?.length || 0 }} </ion-badge> para visualizar indivíduos</span>
              </ion-note>
            </ion-label>
            <ion-icon slot="end" color="success" size="large" *ngIf="jornada?.inicio" (click)="addEspecime(m, met)"
                      name="add-circle-outline"/>

          </ion-item>
          <ion-list *ngIf="exibirEspecime">
            <ion-item-sliding *ngFor="let esp of especiesByMetodo(m, met)">
              <ion-item button (click)="showIndividuos(esp)" detail="true">
                <!--            <ion-icon/>-->
                <ion-label><h3>{{ esp.dataHora| date   : 'dd/MM/yy HH:mm ' }}{{ esp.taxon?.name }}</h3></ion-label>
              </ion-item>
              <ion-item-options>
                <ion-item-option>
                  <ion-icon slot="icon-only" name="pencil-outline"></ion-icon>
                </ion-item-option>
                <ion-item-option color="danger">
                  <ion-icon slot="icon-only" name="trash"></ion-icon>
                </ion-item-option>
              </ion-item-options>
            </ion-item-sliding>
          </ion-list>
        </div>
      </div>


    </ion-list>
  </form>
  <div style="height: 300px">
    <app-tracking id="track"/>
  </div>
</ion-content>

<ion-footer>
  <ion-note *ngIf="jornada?.inicio">
    Dur.: {{ duracao }}
    Pts.: {{ contagem }}
  </ion-note>
</ion-footer>

<ion-alert
  [isOpen]="isAlertOpen"
  title="Finalizar"
  header="Tem certeza que deseja finalizar a jornada/tracking?"
  [buttons]="alertButtons"
/>
